import React from 'react';

import { observer } from 'mobx-react-lite';
import {
  DefaultQueryParams,
  FreeBetsWrapper,
  parseQuery,
  useLobbyStore,
} from '@pascal/pascal-core';
import { useLocation } from 'react-router-dom';
import { GameCardHolderContainer } from '../../conatiners/gameCardHolderContainer';
import { ShuffleCardsWrapper } from '../../components/shuffleCardWraper';
import { RoundInfo } from '../../components/roundInfo';
import { RoundCards } from '../../components/roundCards';
import { WinBetType } from '../../components/winBetType';
import { winningAmountStore } from '../../store/winningAmountStore';
import { BetTypesWrapper } from '../../conatiners/betTypes';
import { CardHolderMobileView } from '../../components/cardHolderView';
import { StatisticsMobile } from '../../conatiners/statisticsMobile';
import { ChipActionWrapper } from '../../components/chipsActionWrapper/chipActionWrapper';
import { MobileWinPopup } from '../../components/mobileWinPopUp';
import { cardsStore } from '../../store/cardsStore';
import Logo from '../../components/logo';
import { TURBO_GAME_ID } from '../../enums/constants';
import { MobileChipSection } from '../../components/mobileChipSection';
import { gameStore } from '../../store/gameStore';

export const MobileGameMain = observer(({ isReplay }) => {
  const { roomName } = useLobbyStore();
  const { winningAmountByMode } = winningAmountStore;
  const { isShuffle } = cardsStore;
  const { search } = useLocation();
  const { [DefaultQueryParams.GameId]: gameId } = parseQuery(search);
  const isTurbo = +gameId === TURBO_GAME_ID;
  const { isBetsClosed } = gameStore;

  return (
    <div className={`baccarat-game-page ${isTurbo ? 'is-turbo' : ''}`}>
      <FreeBetsWrapper />
      <div className='baccarat-game-page-top'>
        <div
          className={`baccarat-game-top-container ${isTurbo ? 'orange' : roomName.toLowerCase()} `}
        >
          <div className='baccarat-game-top-container-inner'>
            <Logo />
            {!isShuffle ? <GameCardHolderContainer innerComp={CardHolderMobileView} /> : null}
            {isShuffle ? <ShuffleCardsWrapper /> : null}
            {!isReplay && <RoundInfo />}
            <RoundCards />
            <WinBetType />
          </div>
        </div>
        {winningAmountByMode ? <MobileWinPopup winningAmount={winningAmountByMode} /> : null}
      </div>
      {isTurbo && !isShuffle && !isBetsClosed && <MobileChipSection />}
      <div className='betting-block-mob'>
        {!isShuffle && !isReplay ? <ChipActionWrapper /> : null}
        {!isReplay && <StatisticsMobile />}
      </div>
      <BetTypesWrapper />
    </div>
  );
});
